'use client'
import React, { useRef, useState } from 'react'
import { useLocale, useTranslations } from 'next-intl'
import LinksDropdownMenu from './linksPopupMenu/LinksPopupMenu'
import { DownArrowIcon, GlobeIcon } from './icons'
import { routing, usePathname } from '../../i18n/routing' // Ensure this import is correct
import { handleLocaleFormat } from '../utils/helpers'

const LanguageSwitcher = () => {
  const currentLocale = useLocale()
  const pathname = usePathname() || '/'
  const t = useTranslations('LocaleSwitcher')
  const [showDropdown, setShowDropdown] = useState(false)
  const langSwitchRef = useRef()

  const withoutCurrentLocale = routing.locales.filter(
    (locale) => locale !== currentLocale
  )

  const handleToggleDropdown = (event) => {
    event.stopPropagation()
    setShowDropdown((prev) => !prev)
  }

  return (
    <div className='flex flex-row justify-start items-stretch flex-nowrap mt-16 sm:mt-12'>
      <div
        ref={langSwitchRef}
        onClick={handleToggleDropdown}
        className='gap-[10px] flex items-center relative cursor-pointer h-fit w-fit'
      >
        <div className='flex items-center text-[14px] leading-none font-light gap-[10px]'>
          <GlobeIcon />
          {t('currentLocale', { currentLocale: handleLocaleFormat(currentLocale) })}
        </div>
        <DownArrowIcon />

        {showDropdown && (
          <LinksDropdownMenu
            maxWidth='fit'
            languagesLinks={withoutCurrentLocale}
            pathname={pathname}
            setShowDropdown={setShowDropdown}
            currentLocale={currentLocale}
            t={t}
            parentRef={langSwitchRef}
          />
        )}
      </div>
    </div>
  )
}

export default LanguageSwitcher
